import {
  ContractChangeValidationListFragment,
  EmployeeLevelEnum,
  NationalContractLevelEnum,
  ContractChangeValidationEntryFragment,
  GovernmentJobTitleTinyDto,
} from '../../../../types'

export const transformNullToUndefined = <T>(value: T | null | undefined): T | undefined => {
  if (value === null) {
    return undefined
  }

  return value
}

export type UndefinedContractChangeValuesForGivenMonth = {
  salary: number
  bonus: number
  employeeLevel: EmployeeLevelEnum
  nationalContractLevel?: NationalContractLevelEnum
  governmentJobTitle?: GovernmentJobTitleTinyDto
}

// MEP-710-TO-VERIFY
export const getDateByMonthForValidationWithBackdating = (month: number, year?: number): Date => {
  if (year === undefined) {
    const now = new Date(new Date().toUTCString())
    year = now.getFullYear()
  }

  const currentYear = new Date().getUTCFullYear()
  const currentMonth = new Date().getUTCMonth()

  if (new Date(currentYear, currentMonth).getTime() > new Date(year, month).getTime()) {
    year = currentYear
    month = currentMonth
  }

  return new Date(Date.UTC(year, month, 1))
}

export const getDateByMonthForValidationWithoutBackdating = (month: number, year?: number): Date => {
  if (year === undefined) {
    const now = new Date(new Date().toUTCString())
    year = now.getFullYear()
  }

  return new Date(Date.UTC(year, month, 1))
}

export const getUndefinedContractChangeValuesForGivenMonth = (
  date: Date,
  contractChangeValidaiontList: ContractChangeValidationListFragment,
): UndefinedContractChangeValuesForGivenMonth => {
  const entries: ContractChangeValidationEntryFragment[] = [
    {
      date: new Date(0),
      salary: 0,
      bonus: 0,
      employeeLevel: EmployeeLevelEnum.None,
      nationalContractLevel: null,
      governmentJobTitle: null,
    },
  ]
  if (contractChangeValidaiontList.validationEntries.length !== 0) {
    for (const entry of contractChangeValidaiontList.validationEntries) {
      entries.push({ ...entry })
    }
    for (let i = 1; i < entries.length; i++) {
      if (entries[i].salary === undefined || entries[i].salary === null) {
        entries[i].salary = entries[i - 1].salary
      }
      if (entries[i].bonus === undefined || entries[i].bonus === null) {
        entries[i].bonus = entries[i - 1].bonus
      }
      if (entries[i].employeeLevel === undefined || entries[i].employeeLevel === null) {
        entries[i].employeeLevel = entries[i - 1].employeeLevel
      }
      if (entries[i].nationalContractLevel === undefined || entries[i].nationalContractLevel === null) {
        entries[i].nationalContractLevel = entries[i - 1].nationalContractLevel
      }
      if (entries[i].governmentJobTitle === undefined || entries[i].governmentJobTitle === null) {
        entries[i].governmentJobTitle = entries[i - 1].governmentJobTitle
      }

      if (date.getTime() < new Date(entries[i].date).getTime()) {
        const gjt = entries[i - 1].governmentJobTitle
        return {
          salary: Number(entries[i - 1].salary),
          bonus: Number(entries[i - 1].bonus),
          employeeLevel: entries[i - 1].employeeLevel as EmployeeLevelEnum,
          nationalContractLevel: entries[i - 1].nationalContractLevel || undefined,
          governmentJobTitle: gjt ? { hiringOfficeCode: gjt.hiringOfficeCode, department: gjt.department, title: gjt.title } : undefined,
        }
      }
    }
  }

  const latest = entries.reverse()[0]
  return {
    salary: Number(latest.salary),
    bonus: Number(latest.bonus),
    employeeLevel: latest.employeeLevel as EmployeeLevelEnum,
    nationalContractLevel: latest.nationalContractLevel || undefined,
    governmentJobTitle: latest.governmentJobTitle
      ? {
          hiringOfficeCode: latest.governmentJobTitle.hiringOfficeCode,
          department: latest.governmentJobTitle.department,
          title: latest.governmentJobTitle.title,
        }
      : undefined,
  }
}

export const getContractChangeValuesForLastDefinedMonth = (
  contractChangeValidaiontList: ContractChangeValidationListFragment,
): UndefinedContractChangeValuesForGivenMonth => {
  const entries: ContractChangeValidationEntryFragment[] = [
    {
      date: new Date(0),
      salary: 0,
      bonus: 0,
      employeeLevel: EmployeeLevelEnum.None,
      nationalContractLevel: null,
      governmentJobTitle: null,
    },
  ]
  if (contractChangeValidaiontList.validationEntries.length !== 0) {
    for (const entry of contractChangeValidaiontList.validationEntries) {
      entries.push({ ...entry })
    }
    for (let i = 1; i < entries.length; i++) {
      if (entries[i].salary === undefined || entries[i].salary === null) {
        entries[i].salary = entries[i - 1].salary
      }
      if (entries[i].bonus === undefined || entries[i].bonus === null) {
        entries[i].bonus = entries[i - 1].bonus
      }
      if (entries[i].employeeLevel === undefined || entries[i].employeeLevel === null) {
        entries[i].employeeLevel = entries[i - 1].employeeLevel
      }
      if (entries[i].nationalContractLevel === undefined || entries[i].nationalContractLevel === null) {
        entries[i].nationalContractLevel = entries[i - 1].nationalContractLevel
      }
      if (entries[i].governmentJobTitle === undefined || entries[i].governmentJobTitle === null) {
        entries[i].governmentJobTitle = entries[i - 1].governmentJobTitle
      }
    }
  }

  const latest = entries.reverse()[0]
  return {
    salary: Number(latest.salary),
    bonus: Number(latest.bonus),
    employeeLevel: latest.employeeLevel as EmployeeLevelEnum,
    nationalContractLevel: latest.nationalContractLevel as NationalContractLevelEnum,
    governmentJobTitle: latest.governmentJobTitle
      ? {
          hiringOfficeCode: latest.governmentJobTitle.hiringOfficeCode,
          department: latest.governmentJobTitle.department,
          title: latest.governmentJobTitle.title,
        }
      : undefined,
  }
}
